{
  "attached": {
    "acceptedOnly": "Accepted data only",
    "anyKind": "Any",
    "chosen": "Chosen labels and terms",
    "clear": "Clear filters",
    "facets": "Labels and terms",
    "facetsPlaceholder": "Choose a label or term",
    "filters": "Filters",
    "inState": "{{kind}}, {{state}}",
    "kind": "Data attached",
    "label": "label",
    "noFacets": "No label or term by that name.",
    "nothing": "Nothing attached",
    "remove": "Remove {{name}}",
    "term": "term"
  },
  "corpora": {
    "all": "All corpora are searched. Untick one to leave it out.",
    "field": "Search text or key",
    "legend": "Corpora",
    "noneTicked": "Tick at least one corpus to search."
  },
  "filters": {
    "segment": "Search in",
    "statements": "Attached statements",
    "wholeDocument": "Whole document"
  },
  "fuzzyRefused": "Fuzzy words such as word~1 need the full search. This installation runs the light search. Remove the ~ and search again.",
  "library": {
    "artifactTypes": "Artifact types",
    "everything": "Everything",
    "filter": "Show",
    "kinds": "Kinds"
  },
  "noHits": "Nothing found.",
  "searching": "Searching…",
  "showMore": "Show more",
  "syntax": {
    "address": "Add @version or #segment to a key to open that version or segment.",
    "fuzzy": "word~1 or word~2 also finds words with one or two letters changed.",
    "fuzzyLightMode": "Fuzzy words need the full search. This installation runs the light search, so they don't work here.",
    "key": "A key as the list shows it, in full or short, finds its document first.",
    "or": "OR between words finds either of them: letter OR charter.",
    "phrase": "\"…\" finds the exact phrase within one segment.",
    "title": "How to search",
    "words": "Every word must occur. You may write AND between them."
  }
}
